// src/pages/ChangePasswordPage.jsx
import { useState } from 'react';
import { supabase } from '../lib/supabase';

export default function ChangePasswordPage() {
  const [pw1, setPw1] = useState('');
  const [pw2, setPw2] = useState('');
  const [status, setStatus] = useState(null);
  const [saving, setSaving] = useState(false);

  async function handleSave(e) {
    e.preventDefault();
    setStatus(null);
    if (!pw1 || pw1.length < 8) { setStatus({ type:'error', msg:'Password must be at least 8 characters.' }); return; }
    if (pw1 !== pw2) { setStatus({ type:'error', msg:'Passwords do not match.' }); return; }

    setSaving(true);
    const { error } = await supabase.auth.updateUser({ password: pw1 });
    setSaving(false);

    if (error) setStatus({ type:'error', msg: error.message || 'Failed to update password.' });
    else {
      setPw1(''); setPw2('');
      setStatus({ type:'success', msg:'Password updated.' });
    }
  }

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <div className="page-title">Change Password</div>
          <div className="page-subtitle">Updates your password in Supabase Auth</div>
        </div>
      </div>

      <div className="page-body">
        {status?.type === 'success' && <div className="alert alert-success">✓ {status.msg}</div>}
        {status?.type === 'error' && <div className="alert alert-danger">✕ {status.msg}</div>}

        <div className="card" style={{ maxWidth: 520 }}>
          <div className="card-body">
            <form onSubmit={handleSave} className="form">
              <div className="form-row">
                <label className="form-label">New password</label>
                <input className="form-input" type="password" value={pw1} onChange={e=>setPw1(e.target.value)} autoComplete="new-password" />
              </div>
              <div className="form-row">
                <label className="form-label">Confirm new password</label>
                <input className="form-input" type="password" value={pw2} onChange={e=>setPw2(e.target.value)} autoComplete="new-password" />
              </div>
              <button className="btn btn-primary" type="submit" disabled={saving}>
                {saving ? 'Saving…' : 'Update password'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
